import React, {FC} from 'react';

/** 订阅购买协议中文正文（i18n：壳组件按语言选择 zh/en 内容组件，类名复用 TermsOfUse__* BEM） */
const ZhContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">生效时间: 2026年8月28日</p>
      <p className="v3-doc-meta">上次更新时间: 2026年8月28日</p>
      <p>欢迎您使用象寄（以下简称“象寄”）提供的订阅服务！</p>
      <p>
        象寄向您提供包括但不限于图片翻译、图片编辑、商品图片生成、商品详情套图生成、商品主图及副图生成以及其他AI视觉内容创作相关的收费增值服务（以下简称“订阅服务”）。
      </p>
      <p>
        为使用象寄的订阅服务，您需要根据象寄公布的收费标准购买相应的订阅套餐。请您在购买和使用订阅服务前，仔细阅读并充分理解本《象寄订阅服务购买协议》（以下简称“本协议”）的全部内容。
      </p>
      <p>
        <strong>
          象寄特别提示您重点阅读本协议中涉及免除或者限制象寄责任、限制用户权利、服务变更、退款、账号管理、自动续费、法律责任及争议解决等内容。前述条款可能涉及您的重大权益，请您在购买订阅服务前务必仔细阅读。
        </strong>
      </p>
      <p>
        如果您不同意本协议的任意或全部内容，请不要购买或使用象寄订阅服务。您通过点击“立即购买”“确认购买”“同意并支付”或其他类似按钮，或者完成支付、开始使用订阅服务等行为，即视为您已经充分阅读、理解并同意接受本协议全部条款的约束。
      </p>
      <p>如果您未满18周岁，请在法定监护人的陪同下阅读并确认本协议，并在获得法定监护人同意后购买和使用订阅服务。</p>
      <section>
        <h2>一、协议的定义及说明</h2>
        <ol>
          <li>
            <strong>象寄</strong>
            <p>
              “象寄”是指 <strong>[苏州象寄科技服务有限公司]</strong>
              及其运营的象寄网站、网页应用、客户端、浏览器插件及其他相关产品和服务。
            </p>
            <p>象寄官方网站为：</p>
            <p>
              <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
                <strong>https://www.xiangjifanyi.com/</strong>
              </a>
            </p>
            <p>具体服务入口及实际提供服务的平台，以象寄官方页面公布的信息为准。</p>
          </li>
          <li>
            <strong>用户</strong>
            <p>用户是指注册、登录象寄账号并购买或使用象寄订阅服务的自然人、法人或非法人组织。</p>
            <p>本协议中“您”“用户”均指订阅服务的购买者及实际使用者。</p>
          </li>
          <li>
            <strong>订阅服务</strong>
            <p>
              订阅服务是指象寄根据用户购买的具体订阅套餐，在约定的订阅周期内向用户提供相应的AI视觉内容创作及相关增值服务。
            </p>
            <p>具体服务内容可能包括但不限于：</p>
            <ul>
              <li>商品图片翻译；</li>
              <li>商品图片编辑；</li>
              <li>商品图片生成；</li>
              <li>商品场景图生成；</li>
              <li>商品模特图生成；</li>
              <li>商品主图、副图生成；</li>
              <li>商品详情套图生成；</li>
              <li>商品详情页、A+页面等内容生成；</li>
              <li>视频及其他视觉内容处理；</li>
              <li>象寄不时推出的其他AI视觉内容服务。</li>
            </ul>
            <p>
              <strong>
                具体服务内容、套餐权益、使用次数、额度、有效期、处理规格及其他服务规则，以用户购买时相应页面实际展示的内容为准。
              </strong>
            </p>
          </li>
          <li>
            <strong>订阅套餐</strong>
            <p>
              订阅套餐是指象寄根据不同用户需求提供的不同服务组合，包括但不限于月度订阅、季度订阅、年度订阅及其他周期性订阅产品。
            </p>
            <p>不同订阅套餐的价格、服务内容、使用额度及权益可能存在差异，具体以购买页面展示为准。</p>
          </li>
          <li>
            <strong>订阅周期</strong>
            <p>订阅周期是指用户购买某一订阅套餐后，可以享受相应订阅权益的有效期间。</p>
            <p>订阅周期可能包括月度、季度、年度或象寄提供的其他周期，具体以购买页面显示为准。</p>
          </li>
          <li>
            <strong>订阅权益</strong>
            <p>订阅权益是指用户在订阅周期内，根据所购买套餐获得的服务额度、功能权限及其他权益。</p>
            <p>
              <strong>不同套餐所对应的订阅权益可能不同，具体以购买页面及象寄官方公布的规则为准。</strong>
            </p>
          </li>
          <li>
            <strong>本协议</strong>
            <p>本协议是象寄用户服务协议、隐私政策、AI相关服务协议及其他相关服务规则的重要组成部分。</p>
            <p>本协议与前述协议共同构成象寄与用户之间关于订阅服务的完整约定。</p>
            <p>
              如本协议与其他协议就订阅服务存在不一致的，以本协议关于订阅服务的约定为准；其他事项仍按照相关协议执行。
            </p>
          </li>
          <li>
            <strong>服务规则</strong>
            <p>
              本协议内容同时包括象寄根据业务发展需要发布的相关公告、页面说明、产品规则、计费规则、帮助文档及其他服务规范。
            </p>
            <p>上述内容一经正式发布，即构成本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
          </li>
        </ol>
      </section>
      <section>
        <h2>二、订阅服务的购买与使用</h2>
        <ol>
          <li>账号及购买</li>
        </ol>
        <p>1.1 您需要注册或登录象寄账号后购买订阅服务。</p>
        <p>您在象寄平台使用的账号，是象寄识别您身份及提供订阅权益的主要依据。</p>
        <p>1.2 您应妥善保管自己的账号、密码及相关账号信息，并对通过您账号进行的操作承担相应责任。</p>
        <p>
          <strong>未经象寄书面许可，您不得以出租、出借、转让、共享、出售等方式向其他主体提供账号使用权。</strong>
        </p>
        <p>
          如象寄发现账号存在异常登录、批量共享、恶意使用或其他影响平台正常运营的情况，象寄有权采取限制登录、限制功能、暂停服务或其他合理措施。
        </p>
        <p>1.3 如您通过第三方账号登录象寄，您应确保该第三方账号真实、合法、有效。</p>
        <p>因第三方账号本身原因导致您无法登录象寄或无法正常使用订阅服务的，您应与相应第三方联系解决。</p>
        <p>1.4 您应确保购买订阅服务时所填写的信息真实、准确、完整。</p>
        <p>因您填写错误、选择错误或操作不当造成的损失，由您自行承担。</p>
      </section>
      <section>
        <h2>三、订阅套餐及费用</h2>
        <ol>
          <li>
            订阅价格
            <p>不同订阅套餐的价格、计费周期及具体权益，以象寄官方购买页面实际显示为准。</p>
            <p>
              象寄有权根据产品运营情况、市场变化及成本变化调整订阅套餐价格，但对于已经购买且尚在有效期内的订阅服务，除法律法规另有规定或双方另有约定外，不因后续价格调整而追溯调整。
            </p>
          </li>
          <li>
            订阅权益
            <p>用户购买订阅套餐后，可在订阅有效期内按照对应套餐规则使用相关服务。</p>
            <p>不同功能可能按照不同的计费方式计算，包括但不限于：</p>
            <ul>
              <li>按次计费；</li>
              <li>按图片数量计费；</li>
              <li>按生成任务计费；</li>
              <li>按处理时长计费；</li>
              <li>按服务额度计费；</li>
              <li>按套餐包含的使用次数或额度计费。</li>
            </ul>
            <p>
              <strong>具体扣费标准及消耗规则以实际使用功能页面展示为准。</strong>
            </p>
          </li>
          <li>
            权益有效期
            <p>除购买页面另有说明外，订阅权益仅在对应订阅周期内有效。</p>
            <p>订阅周期届满后，未使用完毕的订阅额度、次数或其他临时性权益是否结转，以具体套餐规则为准。</p>
            <p>
              <strong>如购买页面明确说明相关额度不支持结转，则订阅周期届满后未使用的额度自动失效。</strong>
            </p>
          </li>
          <li>
            套餐升级
            <p>如象寄提供套餐升级服务，用户可以按照购买页面展示的规则进行升级。</p>
            <p>升级涉及的补差价、剩余周期及权益计算方式，以象寄实际页面展示的规则为准。</p>
          </li>
          <li>
            套餐降级
            <p>如象寄提供套餐降级服务，降级规则以购买页面实际显示为准。</p>
            <p>部分套餐可能不支持直接降级，用户可以在当前订阅周期结束后重新选择其他套餐。</p>
          </li>
        </ol>
      </section>
      <section>
        <h2>四、自动续费服务</h2>
        <p>如象寄提供自动续费功能，用户购买时应特别注意自动续费相关说明。</p>
        <p>
          1.如用户主动选择开通自动续费服务，则在当前订阅周期届满前，象寄可能按照用户选择的续费周期及届时适用的续费价格，通过用户授权的支付方式自动扣除下一周期的订阅费用。
        </p>
        <p>2.自动续费的具体价格、扣款时间、续费周期及取消方式，以用户购买及管理页面显示的信息为准。</p>
        <p>
          3.
          <strong>
            用户可以按照象寄页面提供的方式，在下一次自动扣款前取消自动续费。取消自动续费后，用户已经购买的当前订阅周期不受影响，仍可使用至当前订阅周期结束。
          </strong>
        </p>
        <p>
          4.如因支付账户余额不足、支付机构限制、银行卡失效或其他非象寄原因导致自动续费失败，象寄不保证能够继续提供下一订阅周期的服务。
        </p>
      </section>
      <section>
        <h2>五、订阅服务的使用规则</h2>
        <ol>
          <li>
            您购买的订阅服务仅限用于象寄平台提供的相关服务。
            <p>
              未经象寄书面许可，您不得通过技术手段、程序、脚本或其他方式绕过、破解或规避象寄的计费、额度、权限或访问控制机制。
            </p>
          </li>
          <li>
            您不得利用象寄服务制作、生成、传播或处理违反法律法规、社会公序良俗或侵犯第三方合法权益的内容。
            <p>包括但不限于：</p>
            <ul>
              <li>违法、欺诈或虚假信息；</li>
              <li>侵犯他人知识产权的内容；</li>
              <li>侵犯他人隐私、肖像权、名誉权等合法权益的内容；</li>
              <li>色情、暴力、恐怖主义、极端主义等违法违规内容；</li>
              <li>其他法律法规或象寄平台规则禁止的内容。</li>
            </ul>
          </li>
          <li>您不得利用象寄服务实施批量注册、恶意调用、刷量、套利、攻击平台、干扰平台正常运行等行为。</li>
          <li>
            如您发现账号存在异常使用情况，应及时联系象寄客服。
            <p>因您自身原因导致账号、密码或支付信息泄露而产生的损失，由您自行承担。</p>
          </li>
        </ol>
      </section>
      <section>
        <h2>六、AI服务特别说明</h2>
        <ol>
          <li>
            AI生成结果
            <p>象寄部分服务基于人工智能模型、算法及第三方AI基础设施提供。</p>
            <p>
              <strong>
                由于人工智能生成具有一定的不确定性，AI生成结果可能存在与您的预期不完全一致、内容错误、文字错误、事实错误、画面瑕疵或其他不可预见情况。
              </strong>
            </p>
            <p>您应在将AI生成内容用于商业活动、商品发布、广告投放或其他用途前进行必要的人工审核。</p>
          </li>
          <li>
            不保证生成结果唯一
            <p>您理解并同意，相同或类似的输入可能产生相同或不同的生成结果，象寄不保证生成结果具有唯一性。</p>
          </li>
          <li>
            AI生成内容的审核责任
            <p>您应对上传至象寄平台的素材以及使用象寄生成、编辑、翻译的最终内容承担相应责任。</p>
            <p>尤其对于商品名称、规格、价格、功能、参数、认证、功效等涉及消费者权益的重要信息，您应进行人工核验。</p>
          </li>
          <li>
            第三方模型及服务
            <p>象寄部分AI功能可能依赖第三方模型、云计算、翻译服务、存储服务或其他技术服务。</p>
            <p>
              因第三方服务发生故障、调整、升级、限制或终止而导致相关功能暂时无法使用的，象寄将在合理范围内采取替代、恢复或其他措施，但在法律允许范围内不对由此造成的间接损失承担责任。
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>七、用户上传内容及知识产权</h2>
        <ol>
          <li>
            您应确保上传至象寄平台的图片、文字、视频、商品信息及其他内容已经获得合法授权。如因您上传、处理或使用的内容侵犯任何第三方的知识产权、肖像权、隐私权或其他合法权益，由此产生的责任由您自行承担。
          </li>
          <li>您通过象寄上传或处理的原始素材，其相关权利原则上仍归您或相应权利人所有。</li>
          <li>
            对于您通过象寄服务生成的内容，其相关权利归属及使用范围，按照适用法律法规以及象寄届时有效的AI服务协议或具体产品规则执行。
          </li>
          <li>
            象寄不会因您正常使用订阅服务而取得您上传内容中依法属于您的知识产权。但为向您提供服务、进行技术处理、存储、传输、展示及实现相关功能，您同意象寄在提供服务所必需的范围内处理相关内容。
          </li>
        </ol>
      </section>
      <section>
        <h2>八、退款及订阅取消</h2>
        <ol>
          <li>用户购买订阅服务前，应充分确认所购买的套餐、订阅周期、价格、权益及适用范围。</li>
          <li>
            除法律法规另有规定、象寄页面另有明确承诺或因象寄自身原因导致服务无法提供外，
            <strong>已经开始使用的订阅服务原则上不支持因用户个人原因退款或兑换为其他服务。</strong>
          </li>
          <li>
            对于尚未开始使用且符合象寄退款规则的订阅订单，用户可以按照象寄官方公布的退款流程申请退款。具体退款条件及处理方式以象寄当时有效的退款规则为准。
          </li>
          <li>如用户通过第三方支付平台完成支付，退款到账时间可能受到相关支付机构处理时间影响。</li>
        </ol>
      </section>
      <section>
        <h2>九、服务调整、中断及终止</h2>
        <ol>
          <li>
            象寄有权根据业务发展、技术升级、市场变化及法律法规要求，对订阅服务进行合理调整，包括但不限于：
            <ul>
              <li>增加或减少服务功能；</li>
              <li>调整套餐内容；</li>
              <li>调整服务额度；</li>
              <li>调整计费方式；</li>
              <li>调整AI模型或技术方案；</li>
              <li>暂停或终止部分服务。</li>
            </ul>
          </li>
          <li>
            对于已经购买且尚在有效期内的订阅服务，如象寄因自身原因永久停止提供相关核心服务，象寄将根据具体情况提供合理的替代方案、延期、退款或其他处理方式。
          </li>
          <li>
            因系统维护、升级、网络故障、第三方服务异常、不可抗力等原因造成服务暂时中断的，象寄将尽合理努力尽快恢复服务。
          </li>
        </ol>
      </section>
      <section>
        <h2>十、特别提示及免责声明</h2>
        <p>
          <strong>
            在法律允许的最大范围内，因下列原因导致用户无法正常使用订阅服务的，象寄不承担由此产生的间接损失或超出法律规定范围的责任：
          </strong>
        </p>
        <ol>
          <li>象寄按照公告进行系统维护、升级或调整；</li>
          <li>电信运营商、网络服务商或其他基础设施故障；</li>
          <li>第三方支付、云服务、AI模型或其他第三方服务异常；</li>
          <li>黑客攻击、病毒、恶意程序等网络安全事件；</li>
          <li>台风、地震、洪水、火灾、战争、政府行为等不可抗力；</li>
          <li>用户自身设备、网络、账号或操作原因；</li>
          <li>用户违反本协议或其他象寄平台规则；</li>
          <li>其他非因象寄自身过错造成的原因。</li>
        </ol>
      </section>
      <section>
        <h2>十一、账号管理及违规处理</h2>
        <ol>
          <li>
            如象寄发现或有合理理由认为用户存在违反法律法规、本协议或其他平台规则的行为，象寄有权根据具体情况采取包括但不限于以下措施：
            <ul>
              <li>警告；</li>
              <li>限制部分功能；</li>
              <li>暂停相关服务；</li>
              <li>限制账号登录；</li>
              <li>暂停或终止账号；</li>
              <li>删除相关违法违规内容；</li>
              <li>根据规则扣除异常获得的服务额度；</li>
              <li>依法向有关部门报告。</li>
            </ul>
          </li>
          <li>如因用户违法违规行为导致象寄遭受第三方索赔、行政处罚、司法追责或其他损失，用户应依法承担相应责任。</li>
          <li>如用户账号被暂停或终止使用，用户仍应按照法律法规及相关协议承担已经产生的责任。</li>
        </ol>
      </section>
      <section>
        <h2>十二、交易异常及系统故障</h2>
        <ol>
          <li>
            如因象寄系统故障导致用户实际购买的订阅权益与订单记录不一致，用户可以通过客服渠道提供相关支付凭证及订单信息。
            经象寄核实确认后，象寄将根据实际情况采取补充权益、更正订单或其他合理处理措施。
          </li>
          <li>如因系统故障导致用户获得超出实际支付金额对应的订阅权益，象寄有权对异常权益进行更正或追回。</li>
          <li>
            如发现用户利用系统漏洞、技术手段或其他方式获取异常订阅权益，象寄有权取消相关异常权益，并根据情节采取进一步措施。
          </li>
        </ol>
      </section>
      <section>
        <h2>十三、协议变更</h2>
        <p>象寄有权根据法律法规、业务发展及服务变化对本协议进行修改。</p>
        <p>协议发生重大变更时，象寄将通过网站公告、产品页面、站内通知或其他合理方式向用户进行提示。</p>
        <p>
          <strong>
            如您不同意修改后的协议，可以停止使用相关订阅服务；如您继续购买或使用订阅服务，则视为您已经接受修改后的协议。
          </strong>
        </p>
        <p>更新后的协议自公布或约定的生效日期起生效。</p>
      </section>
      <section>
        <h2>十四、联系象寄</h2>
        <p>如果您对本协议、订阅服务、订单、退款或其他相关问题存在疑问，可以通过以下方式联系象寄：</p>
        <ul>
          <li>
            官方网站：
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>在线客服：象寄产品内在线客服</li>
          <li>客服邮箱：510807298@qq.com</li>
          <li>公司名称：苏州象寄科技服务有限公司</li>
          <li>
            公司地址：<strong>上海市浦东新区纳贤路800号科海大楼</strong>
          </li>
        </ul>
        <p>象寄将在收到您的咨询、投诉或意见后，在合理期限内进行处理。</p>
      </section>
      <section>
        <h2>十五、法律适用及争议解决</h2>
        <ol>
          <li>本协议的订立、生效、履行、解释及争议解决均适用中华人民共和国法律。</li>
          <li>如因本协议或订阅服务产生任何争议，双方应首先通过友好协商解决。</li>
          <li>
            如协商不成，双方同意将争议提交至<strong>象寄实际运营主体住所地有管辖权的人民法院</strong>解决。
          </li>
          <li>如本协议任何条款因与现行法律法规相冲突而被认定为无效或不可执行，不影响本协议其他条款的效力。</li>
        </ol>
      </section>
      <section>
        <h2>十六、协议生效</h2>
        <p>
          您点击“同意并购买”“确认购买”“立即支付”或其他具有类似含义的按钮，或者实际支付订阅费用并开始使用订阅服务，即视为您已经阅读、理解并同意本协议全部内容。
        </p>
        <p>
          <strong>本协议自您完成订阅服务购买之日起生效，并在您使用订阅服务期间持续有效。</strong>
        </p>
      </section>
    </>
  );
};

export default ZhContent;
